import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = { class: "m-0 font-bold text-textPrimary" }
const _hoisted_3 = ["data-testid"]


export default /*#__PURE__*/_defineComponent({
  __name: 'PriorityPaymentsEmptyState',
  props: {
    hasFilters: { type: Boolean },
    testId: { default: 'priority-payments-empty-state' }
  },
  emits: ["clear-filters"],
  setup(__props: any, { emit }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex w-full flex-col items-center justify-center gap-4 py-16 text-center",
    "data-testid": _ctx.testId
  }, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.hasFilters
          ? 'Nenhum plantão com esses filtros. Remova um atalho ou amplie o período.'
          : 'Nenhum plantão de pagamento prioritário neste ciclo.'), 1),
    (_ctx.hasFilters)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "rounded-md border border-lightGray30 px-4 py-2 text-sm font-medium text-textPrimary",
          "data-testid": `${_ctx.testId}-clear`,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('clear-filters')))
        }, " Limpar filtros ", 8, _hoisted_3))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})